import LogPane from 'Components/Panes/LogPane';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getAllDebugMessages } from 'Store/Actions/debugActions';
import { useAppSelector } from 'Store/hooks';
import { usePolling } from 'Util/usePolling';

const DeviceLogsPane:React.FC = () => {
  const debugDispatch = useDispatch();
  const [messages, setMessages] = useState<string[]>([] as string[]);
  const { allDebugMessages } = useAppSelector(state => state.debug);
  useEffect(() => {
    getAllDebugMessages(debugDispatch)();
  }, [debugDispatch]);
  useEffect(() => {
    if (allDebugMessages) {
      setMessages(allDebugMessages?.map(m => `${m.timestamp}: ${m.message}\n`));
    }
  }, [allDebugMessages]);
  usePolling(async () => {
    getAllDebugMessages(debugDispatch)();
  }, 10000);
  return (
    <LogPane logData={messages} />
  );
};
export default DeviceLogsPane;
